/**
 *
 * @param a
 * @returns {*}
 */
export const extractId = a => (typeof a === "number" ? a : a ? a.id : null);

/**
 *
 * @param a
 * @returns {Object}
 */
export const idify = a =>
  a !== null && typeof a === "object" && a.hasOwnProperty("hasOwnProperty")
    ? a
    : { id: a };

/**
 * @param {Array} a
 * @returns {*}
 */
export const extractIds = a => a.map(extractId);

/**
 *
 * @param a
 * @returns {*}
 */
export const log = a => {
  // eslint-disable-next-line
  console.log(a);
  return a;
};

/**
 * @param a
 * @param b
 * @returns {boolean}
 */
export const ie = (a, b) => parseInt(a, 10) === parseInt(b, 10);

/**
 * @param a
 * @param b
 * @param {string} key
 * @returns {boolean}
 */
export const ke = (a, b, key) => a[key] === b[key];

/**
 *
 * @param key
 * @returns {function(*, *): (number | bigint | T | T | * | null)}
 * @private
 */
export const by_ = key => (haystack, needle) =>
  haystack.find(a => a[key] === needle) || null;

/**
 *
 * @param key
 * @returns {Function}
 * @private
 */
export const get_ = key => (haystack, item, _key) => {
  if (!item) return null;
  const c = haystack.find(a => ke(a, item, _key));
  return (c && c[key]) || null;
};

/**
 *
 * @param key
 * @returns {function(*=, *): *}
 * @private
 */
export const has_ = key => (haystack, item) => by_(key)(haystack, item);

/**
 *
 * @type {function(*, *=): (number|bigint|T|*|null)}
 */
export const byId = by_("id");
/**
 *
 */
export const getId = get_("id");
/**
 *
 * @type {function(*=, *): *}
 */
export const hasId = has_("id");
/**
 *
 * @type {function(*, *=): (number|bigint|T|*|null)}
 */
export const byUuid = by_("uuid");
/**
 *
 */
export const getUuid = get_("uuid");
/**
 *
 * @type {function(*=, *): *}
 */
export const hasUuid = has_("uuid");

export const kvChangeKey = type => `KV_CHANGE_${type}`;
export const partnerChangeKey = () => `PARTNER_CHANGE`;
export const contactChangeKey = () => `CONTACT_CHANGE`;

/**
 *
 * @param str
 * @returns {*}
 */
export const strToCommonNameFormat = str => {
  let a = str.trim();
  if (!a.length) return { first_name: "John", last_name: "Doe" };
  a = a.split(" ");
  if (a.length < 2) return { first_name: "John", last_name: "Doe" };
  if (a.length === 2) return { first_name: a[0], last_name: a[1] };
  return { first_name: a[0], last_name: a.slice(1).join(" ") };
};
